import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { resetPassword } from 'apis/employees.api';
import Loading from 'components/Loading';
import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';

export default function ConfirmResetPassword({ selectedEmployee, visible, setVisible, refetch }) {
  // #region Data
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation(resetPassword);
  // #endregion

  // #region Event
  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('employee.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('employee.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          mutate(
            { email: selectedEmployee.email },
            {
              onSuccess: () => {
                toast(TOAST.SUCCESS, t('employee.resetPassword.resetPasswordSuccess'));
                setVisible(false);
                refetch();
              },
              onError: (error) => {
                toast(TOAST.ERROR, mapError(t, error));
              },
            }
          );
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={<p className="text-orange-500">{t('employee.resetPassword.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg">{t('employee.resetPassword.confirmationResetPasswordMessage')}</p>
      <p className="text-lg font-bold">
        {selectedEmployee?.fullname} ({selectedEmployee?.email})
      </p>
      {isLoading && <Loading />}
    </Dialog>
  );
}

ConfirmResetPassword.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  selectedEmployee: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};
